module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_diamonds-queen.93aec03f.svg";